import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import IconClose from '@material-ui/icons/Close';
import IconCheckCircle from '@material-ui/icons/CheckCircle';
import IconCancel from '@material-ui/icons/Cancel';

import LiberacaoAcesso from '../../components/LiberacaoAcesso';

const ModalConfirmacao = ({ title, body, options, rotina, open, onClose, onCloseCallback }) => {
  const [disableModal, setDisableModal] = useState(true);
  const [tokenLiberacaoRotina, setTokenLiberacaoRotina] = useState(null);

  return (
    <Dialog
      open={open}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          onClose();
        }
      }}
      PaperComponent={Paper}
      maxWidth={'md'}
    >

      <DialogContent style={{ width: 560, display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '32px', paddingBottom: '16px', paddingLeft: '32px', paddingRight: '32px' }}>
        <Box textAlign="center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: 0, gap: '16px'}}>
          <Typography variant="h2" style={{ margin: 0 }}>{title}</Typography>
          <Typography variant="h5" style={{ margin: 0 }}>{body}</Typography>
        </Box>

        {disableModal && (
          <LiberacaoAcesso
            orientation="vertical"
            rotina={rotina}
            callback={(acesso, token) => {
              setDisableModal(!acesso);
              if (acesso) {
                setTokenLiberacaoRotina(token);
              }
            }}
          />
        )}
      </DialogContent>

      <DialogActions style={{ paddingTop: disableModal ? '0px' : '16px', paddingBottom: '32px', paddingLeft: '32px', paddingRight: '32px', alignItems: 'stretch' }}>
        <Button
          variant="contained"
          className={`button-${options.icon}`}
          disabled={disableModal}
          onClick={() => onCloseCallback(tokenLiberacaoRotina)}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            { options.icon === 'warning'
            ? <IconCancel style={{position: 'relative', bottom: '2px'}}/>
            : <IconClose style={{position: 'relative', bottom: '2px'}}/>}
            <span style={{ verticalAlign: 'middle' }}>{options?.confirmButtonText}</span>
          </span>
        </Button>

        <Button size="large" onClick={onClose}>
          {options?.cancelButtonText ?? 'Cancelar'}
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default ModalConfirmacao;
